import { Route, Routes } from "react-router-dom"

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HomePage from "../pages/HomePage";
import QuizPage from '../pages/QuizPage/QuizPage';
import ResultPage from "../pages/ResultPage";



export const AppRouter = () => {
    return <>
        {
            window.location.pathname === "/" &&
            <Navbar />
        }
        <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/quiz' element={<QuizPage />} />
            <Route path='/result' element={<ResultPage />} />
        </Routes>
        {
            window.location.pathname === "/" &&
            <Footer />
        }
    </>
}